module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ioLkS"))).then(() => module.bundle.root('d0iPb'));